import { Injectable } from '@angular/core';
import { Beneficiaire, BeneficiaireRequest, BulkEmployeeResponse, EmployeeInput } from '../models/beneficiaire';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BeneficiaireService {
  private apiUrl = environment.backClient;
  private apiWalletUrl = environment.backWallet;

  constructor(private http: HttpClient) {}

  // 🔁 Récupère le token à jour à chaque appel
  private get token(): string | null {
    return localStorage.getItem('token');
  }

  // 🔐 Centralise les headers
  private get headers(): { headers: HttpHeaders } {
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
        'Content-Type': 'application/json',
      }),
    };
  }

  // 👥 Récupérer tous les employés
  getAllEmployes(): Observable<any> {
    return this.http.get<Beneficiaire[]>(
      `${this.apiUrl}/company/employes`,
      this.headers
    );
  }

  // ➕ Ajouter un nouvel employé
  add(userData: BeneficiaireRequest): Observable<Beneficiaire> {
    return this.http.post<Beneficiaire>(
      `${this.apiUrl}/company/registerEmploye`,
      userData,
      this.headers
    );
  }

   bulkRegisterEmployees(
    companyId: string, 
    employees: EmployeeInput[]
  ): Observable<BulkEmployeeResponse> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.http.post<BulkEmployeeResponse>(
      `${this.apiUrl}/company/bulkRegisterEmploye/${companyId}`,
      { employees },
      { headers }
    );
  }

  
removeEmployee(email: string): Observable<any> {
  const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  return this.http.post<any>(
    `${this.apiUrl}/company/removeEmploye`,
    { email: email },
    { headers }
  );
}

  // 🎫 Transférer des tickets aux bénéficiaires
  transferTickets(
    from: string| null,
    to: string,
    ticketId: number,
    amount: number
  ): Observable<any> {
    //get token
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    //console.log('from', from, 'to', to, 'ticketId', ticketId, 'amount', amount);

    return this.http.post(
      `${this.apiWalletUrl}/tokens/transfer`,
      {
        from: from,
        to: to,
        tokenId: ticketId,
        amount: amount,
      },
      { headers }
    );
  }
}
